import { ConfigContext } from 'contexts/config';
import { useContext, useMemo } from 'react';
import { getCurrentCycle } from '../helpers/cycles';
import type { ICycle } from '../types';

export const useCycle = (): ICycle => {
  const { pumpkinRush } = useContext(ConfigContext);

  return useMemo(
    () => getCurrentCycle(pumpkinRush?.start ?? new Date(0).toISOString()),
    [pumpkinRush]
  );
};
